import { useState } from "react";
import { startCheckout } from "../lib/api";
import { track } from "../lib/plausible";

export function Pricing() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const onUpgrade = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    track("upgrade_click");
    try {
      const { url } = await startCheckout(email);
      window.location.href = url;
    } catch (e) {
      setErr(e instanceof Error ? e.message : "Checkout failed");
      setBusy(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto px-6 py-12 space-y-10">
      <header className="text-center space-y-2">
        <h1 className="text-3xl font-semibold">Pricing</h1>
        <p className="text-ink/70">Cancel anytime. 14-day refund on first month.</p>
      </header>
      <div className="grid md:grid-cols-2 gap-6">
        <Plan
          name="Free"
          price="$0"
          features={[
            "5 charts / day per IP",
            "10 MB upload max",
            "CSV + JSON downloads",
            "Side-by-side verification",
          ]}
        />
        <Plan
          name="Paid"
          price="$7/mo"
          highlight
          features={[
            "Unlimited charts",
            "50 MB upload max",
            "Email support, ≤24 h response",
            "Cancel anytime",
          ]}
          cta={
            <form onSubmit={onUpgrade} className="space-y-2">
              <input
                type="email"
                required
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-3 py-2 rounded-md border border-ink/15 text-sm"
              />
              <button type="submit" disabled={busy} className="btn-primary w-full justify-center">
                {busy ? "Redirecting…" : "Upgrade — $7/mo"}
              </button>
              {err && <p className="text-sm text-red-600">{err}</p>}
            </form>
          }
        />
      </div>
      <p className="text-sm text-ink/60 text-center">
        B2B / batch / API tier coming post-launch — reply to your receipt if you want early access.
      </p>
    </div>
  );
}

function Plan({
  name,
  price,
  features,
  highlight,
  cta,
}: {
  name: string;
  price: string;
  features: string[];
  highlight?: boolean;
  cta?: React.ReactNode;
}) {
  return (
    <div
      className={`rounded-lg p-6 space-y-4 ${
        highlight ? "border-2 border-ink bg-ink text-paper" : "border border-ink/15"
      }`}
    >
      <div>
        <div className={`text-sm uppercase tracking-wide ${highlight ? "text-paper/60" : "text-ink/60"}`}>
          {name}
        </div>
        <div className="text-3xl font-semibold">{price}</div>
      </div>
      <ul className="space-y-1.5 text-sm">
        {features.map((f) => (
          <li key={f}>· {f}</li>
        ))}
      </ul>
      {cta}
    </div>
  );
}
